module.exports = __webpack_public_path__ + "overshootInLeft.gif";